/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UpdateSiteContactRequestSiteContactFromJSON, UpdateSiteContactRequestSiteContactToJSON } from './UpdateSiteContactRequestSiteContact';
export function UpdateDocumentContactRequestFromJSON(json) {
    return UpdateDocumentContactRequestFromJSONTyped(json, false);
}
export function UpdateDocumentContactRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        documentContact: !exists(json, 'document_contact')
            ? undefined
            : UpdateSiteContactRequestSiteContactFromJSON(json['document_contact'])
    };
}
export function UpdateDocumentContactRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        document_contact: UpdateSiteContactRequestSiteContactToJSON(value.documentContact)
    };
}
